import { ICauHinhLoaiDichVuItemRequest } from "../../../models/request/dich-vu/cauHinhLoaiDichVuRequests";
import { IDichVuSelectRequest } from "../../../models/request/dich-vu/dichVuRequests";
import { CauHinhLoaiDichVuItemResponse } from "../../../models/response/dich-vu/sf_cauhinh_loaidichvu";
import { sf_loaidichvu } from "../../../models/response/dich-vu/sf_loaidichvu";
import {
	eCauHinhLoaiDichVuActionTypeIds,
	ICauHinhLoaiDichVuChangeSelectedIds,
	ICauHinhLoaiDichVuCloseConfirm,
	ICauHinhLoaiDichVuCloseDetail,
	ICauHinhLoaiDichVuDeleteErr,
	ICauHinhLoaiDichVuDeleteStart,
	ICauHinhLoaiDichVuDeleteSuccess,
	ICauHinhLoaiDichVuLoadDetailErr,
	ICauHinhLoaiDichVuLoadDetailStart,
	ICauHinhLoaiDichVuLoadDetailSuccess,
	ICauHinhLoaiDichVuLoadErr,
	ICauHinhLoaiDichVuLoadStart,
	ICauHinhLoaiDichVuLoadSuccess,
	ICauHinhLoaiDichVuSaveErr,
	ICauHinhLoaiDichVuSaveStart,
	ICauHinhLoaiDichVuSaveSuccess,
	ICauHinhLoaiDichVuShowConfirm,
	ICauHinhLoaiDichVuShowDetail,
	ILoaiDichVuLoadErr,
	ILoaiDichVuLoadStart,
	ILoaiDichVuLoadSuccess
} from "../../action-types/dich-vu/ICauHinhLoaiDichVuActionTypes";

export const cauHinhLoaiDichVuActions = {
	loadCauHinhLoaiDichVuStart: (request: IDichVuSelectRequest): ICauHinhLoaiDichVuLoadStart => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.LOAD_START,
			payload: request
		}
	},
	loadCauHinhLoaiDichVuSuccess: (data: CauHinhLoaiDichVuItemResponse[]): ICauHinhLoaiDichVuLoadSuccess => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadCauHinhLoaiDichVuError: (message: string): ICauHinhLoaiDichVuLoadErr => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadLoaiDichVuStart: (): ILoaiDichVuLoadStart => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.LOAD_LOAIDICHVU_START
		}
	},
	loadLoaiDichVuSuccess: (data: sf_loaidichvu[]): ILoaiDichVuLoadSuccess => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.LOAD_LOAIDICHVU_SUCCESS,
			payload: data
		}
	},
	loadLoaiDichVuError: (message: string): ILoaiDichVuLoadErr => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.LOAD_LOAIDICHVU_ERROR,
			payload: message
		}
	},
	loadCauHinhLoaiDichVuDetailStart: (id: number): ICauHinhLoaiDichVuLoadDetailStart => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.LOAD_DETAIL_START,
			payload: id
		}
	},
	loadCauHinhLoaiDichVuDetailSuccess: (data: CauHinhLoaiDichVuItemResponse): ICauHinhLoaiDichVuLoadDetailSuccess => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.LOAD_DETAIL_SUCCESS,
			payload: data
		}
	},
	loadCauHinhLoaiDichVuDetailError: (message: string): ICauHinhLoaiDichVuLoadDetailErr => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.LOAD_DETAIL_ERROR,
			payload: message
		}
	},
	showCauHinhLoaiDichVuDetail: (data?: CauHinhLoaiDichVuItemResponse): ICauHinhLoaiDichVuShowDetail => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeCauHinhLoaiDichVuDetail: (): ICauHinhLoaiDichVuCloseDetail => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.CLOSE_DETAIL
		}
	},
	changeCauHinhLoaiDichVuSelectedIds: (ids: number[]): ICauHinhLoaiDichVuChangeSelectedIds => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	showCauHinhLoaiDichVuConfirm: (): ICauHinhLoaiDichVuShowConfirm => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.SHOW_CONFIRM
		}
	},
	closeCauHinhLoaiDichVuConfirm: (): ICauHinhLoaiDichVuCloseConfirm => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.CLOSE_CONFIRM
		}
	},
	saveCauHinhLoaiDichVuStart: (data: ICauHinhLoaiDichVuItemRequest): ICauHinhLoaiDichVuSaveStart => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveCauHinhLoaiDichVuSuccess: (is_update: boolean): ICauHinhLoaiDichVuSaveSuccess => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.SAVE_SUCCESS,
			payload: is_update
		}
	},
	saveCauHinhLoaiDichVuError: (message: string): ICauHinhLoaiDichVuSaveErr => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.SAVE_ERROR,
			payload: message
		}
	},
	deleteCauHinhLoaiDichVuStart: (id: number): ICauHinhLoaiDichVuDeleteStart => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteCauHinhLoaiDichVuSuccess: (): ICauHinhLoaiDichVuDeleteSuccess => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteCauHinhLoaiDichVuError: (message: string): ICauHinhLoaiDichVuDeleteErr => {
		return {
			type: eCauHinhLoaiDichVuActionTypeIds.DELETE_ERROR,
			payload: message
		}
	}
}
